/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ModifyGradeRequestViewModel } from "../types/ModifyGradeRequestViewModel.ts";

export const modifyGradeRequestViewModelSchema = z.object({
  grade: z.number().nullish(),
}) as unknown as ToZod<ModifyGradeRequestViewModel>;
